import { render } from "./Appointments.vue?vue&type=template&id=5a5c2735"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=5a5c2735&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__